import * as React from 'react';
import cn from 'classnames';
import style from './heading.mod.scss';
import { motion } from 'framer-motion';
import { TypeAnimation } from 'react-type-animation';

const backgroundVariants = {
  offscreen: {
    width: 0,
    opacity: 0,
    padding: 0,
  },
  onscreen: {
    width: '100%',
    opacity: 1,
    padding: '10px 10px',
    transition: {
      duration: 0.5,
      ease: 'easeOut',
    },
  },
};

const Heading = ({
  tag = 2,
  text,
  size = 'sm',
  light = false,
  primary = false,
  truncate = false,
  marginBottom = false,
  secondary = false,
  animate = false,
  typing = false,
}) => {
  const Tag = `h${tag}`;
  const classes = cn(style.heading, {
    [style[`heading--size-${size}`]]: size,
    [style[`heading--color-light`]]: light,
    [style[`heading--color-primary`]]: primary,
    [style[`heading--truncate`]]: truncate,
    [style[`heading--secondary`]]: secondary,
    [style[`heading--margin-bottom`]]: marginBottom,
    [style[`heading--animate`]]: animate,
  });

  return (
    <div className={classes}>
      {typing ? (
        <div className={style.heading__typing}>
        <TypeAnimation
          sequence={[
            'Whatever you’re striving for, we can help',
            1000,
          ]}
          speed={60}
          wrapper="h1"
          repeat={Infinity}
          />
        </div>
      ) : (
        <>
          <div className={style.heading__background}>
            {animate && (
              <motion.div
                className={style.heading__backgroundFill}
                variants={backgroundVariants}
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.5 }}
              />
            )}
          </div>
          <Tag className={style.heading__text}>{text}</Tag>
        </>
      )}
    </div>
  );
};

export default Heading;
